import React from "react"
import { Box, Typography } from "@mui/material"
import dayjs from "dayjs"
import {DATE_FORMAT_SHOW, DATE_TIME_FORMAT_SHOW, CPF_MASK, CNPJ_MASK, PHONE_MASK, CELLPHONE_MASK } from "src/utils/constants"

// Função para renderizar a célula com uma data formatada
export const renderCellDate = (params) => {
    if (params.value) {
        return dayjs(params.value).format(DATE_FORMAT_SHOW)
    }
    return "" // Retorna string vazia caso o valor seja nulo/indefinido
}

export const renderCellDateTime = (params) => {
    if (params.value) {
        return dayjs(params.value).format(DATE_TIME_FORMAT_SHOW)
    }
    return "" // Retorna string vazia caso o valor seja nulo/indefinido
}

// Função para renderizar uma coluna com texto multilinha
export const renderTextColumn = (params) => (
    <Box sx={{ whiteSpace: "pre-line", height: "auto" }}>
        <Typography component="span">{params.value}</Typography>
    </Box>
)

// Função para calcular a largura mínima com base no conteúdo
export const calculateMinWidth = (rows, field) => {
    const longestText = rows.reduce((longest, row) => {
        const text = row[field] ? row[field].toString() :  "" // Garante que o texto seja uma string
        return text.length > longest.length ? text : longest
    }, "")
    return Math.max(longestText.length * 2, 150) // Largura mínima de 150
}

// funcao para substituir valores de um payload
// exemplo de entrada: [{field: meu_campo, value: valor}]
export const substituirValoresPayload = (objeto, mapeamento) => {
    const novoObjeto = { ...objeto }

    mapeamento.forEach((item) => {
        const { field, value } = item
        const valorOrigem = objeto[field]
        novoObjeto[field] = value !== undefined ? value : valorOrigem
    })

    return novoObjeto
}

const applyMask = (value, mask) => {
    let result = ""
    let index = 0

    for (let i = 0; i < mask.length && index < value.length; i++) {
        if (mask[i] === "9") {
            result += value[index]
            index++
        } else {
            result += mask[i]
        }
    }

    return result
}

export const renderCellCpfCnpj = (params) => {
    if (!params.value) return ""

    const onlyNumbers = params.value.replace(/\D/g, "")

    if (onlyNumbers.length === 11) {
        return applyMask(onlyNumbers, CPF_MASK)
    }

    if (onlyNumbers.length === 14) {
        return applyMask(onlyNumbers, CNPJ_MASK)
    }

    return params.value
}

export const renderCellPhone = (params) => {
    if (!params.value) return ""

    const onlyNumbers = params.value.replace(/\D/g, "")
    // Se tiver 11 dígitos é celular com 9 inicial
    if (onlyNumbers.length === 11) {
        return applyMask(onlyNumbers, CELLPHONE_MASK)
    }
    // Se tiver 10 dígitos é telefone fixo
    if (onlyNumbers.length === 10) {
        return applyMask(onlyNumbers, PHONE_MASK)
    }

    return params.value
}